import { render, staticRenderFns } from "./CustomerSupportsShow.vue?vue&type=template&id=2270a092&"
import script from "./CustomerSupportsShow.vue?vue&type=script&lang=js&"
export * from "./CustomerSupportsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports